// extracted by mini-css-extract-plugin
export default {"list":"NavTabs_list__y4w5u","link":"NavTabs_link__gdPYB","active":"NavTabs_active__Ujp5z"};